



























import Vue from "vue";
import loginService from "@/shared/servicios/loginService";

export default Vue.extend({
  data() {
    return {
      usuario: "",
      password: "",
      formValida: true,
      loginService,
      loginError: "",
      loading: false,
      firstSubmit: false,
      showPass: false
    };
  },
  computed: {
    campos(): any[] {
      return [
        {
          label: "Nombre de usuario",
          model: "usuario",
          icono: "account",
          rules: [(v) => !!v || "Requerido"],
        },
        {
          label: "Contraseña",
          model: "password",
          icono: "key",
          rules: [
            (v: string) => !this.firstSubmit || v?.length >= 6 || "La contraseña debe mínimo 6 caracteres"
          ],
          appendIcon: this.showPass ? "mdi-eye" : "mdi-eye-off",
          type: this.showPass ? "text" : "password",
          clickAppend: () => this.showPass = !this.showPass
        },
      ]
    }
  },
  methods: {
    validarForm() {
      const form = this.$refs.form as any
      const formValida = form.validate();
      console.log({ formValida });

      return formValida;
    },
    login() {

      this.firstSubmit = true

      if (!this.validarForm()) {
        return;
      }

      this.loading = true;

      this.loginService
        .login(this.usuario, this.password)
        .then((res) => {
          this.$router.push("/");
        })
        .catch((e) => {
          console.log("Error en login component:", e);
          this.loginError = e.error_description || e;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
